<template lang="html">
    <div class="HeaderUserInfoContent">
        <div v-if="getUserInfo">
        Welcome {{ getUserInfo.email}}
        <button type="button" v-on:click="logout()">Logout</button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            localStorage.removeItem('userToken')
            location.reload();
        }
    },
    computed: {
        getUserInfo () {
            return this.$store.state.login.userInfos
        }
    }
}
</script>
